<template>
  <section class="page">
    <div class="container">
      <h2 class="title page__h1">ライセンスカードをウォレットに追加</h2>
      <div class="box box--center mb-24">
        <p>
          <ul style="text-align: left;">
            <li>・本機能は、スマートフォン向けに提供しています。</li>
            <li>・現時点で有効なライセンスと今後有効になるライセンスが追加可能なライセンスです。</li>
            <li>・iPhoneをご利用の方は <span class="btn btn-primary btn-sm">iPhone</span> をクリックしてウォレットに追加してください。</li>
            <li>・iPhone以外のスマートフォンをご利用の方は <span class="btn btn-primary btn-sm">Android</span> をクリックしてウォレットに追加してください。
              <br>
              ※予め「Googleウォレット」アプリをインストールしておく必要があります。「Googleウォレット」アプリは、Google Playより入手ください。
            </li>
          </ul>
          <!-- {{ message }} -->
        </p>
      </div>

      <div class="row mt-32 mb-32">
        <div class="col-12 col-md-6 mb-4" v-for="license in get_license_obj" :key="license.id">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title py-1 px-2 text-white" :style="'background-color:' + license.color_cd + ';'">{{ license.license_label }}</h5>
              <p class="card-text">
                年度: {{ license.license_year }}年<br>
                {{ license.license_term_start_date }} 〜 {{ license.license_term_end_date }}
              </p>
              <div class="row">
                <div class="col-md-6 text-center">
                  <button class="btn btn-primary btn-block mb-2" @click="go_wallet_ios(license.id)">iPhone</button>
                </div>
                <div class="col-md-6 text-center">
                  <button class="btn btn-primary btn-block mb-2" @click="go_wallet_android(license.id)">Android</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>

      </div>
      <!-- {{ get_license_obj }} -->
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
// import BsSelect from '../../atoms/BsSelect.vue'
import config from '../../../const'
import Common from '../../../common/common'

export default {
  name: 'UserWalletView',
  data: function () {
    return {
      targetid: this.$store.state.auth.userId,
      btnLabel: '',
      data_obj: {},
      form_obj: {},
      change_login_id: '',
      confirm_login_id: '',
      change_mode: true,
      message:
        '',
      pref_obj: [],
      sex_type_obj: [],
      request_type_cd_obj: [],
      application_obj: [],
      application_type_obj: [],
      application_check_type_obj: [],
      shipping_address_obj: [],
    }
  },
  components: {
    // BsSelect,
    //   BsMsgAlert,
    // BsCheckBox,
  },
  methods: {
    async go_wallet_ios(license_id) {
      try {
        const params = this.setParams_S({
          member_license_id: license_id,
        })

        const response = await axios.post(
          config.BASE_API_URL + '/wallet/ios',
          params,
          {
            ...this.cHeader,
            responseType: 'blob'
          }
        )

        const contentType = response?.headers?.['content-type'] || ''

        if (
          contentType.includes('application/json') ||
          contentType.includes('text/plain')
        ) {
          const text = await response.data.text()
          throw new Error(text || 'Apple Walletデータの取得に失敗しました')
        }

        const blob = new Blob([response.data], {
          type: 'application/vnd.apple.pkpass'
        })

        const blobUrl = window.URL.createObjectURL(blob)

        // 同一タブ遷移
        window.location.href = blobUrl

        // あるいは aタグクリック方式でも可
        // const a = document.createElement('a')
        // a.href = blobUrl
        // a.download = 'member.pkpass'
        // document.body.appendChild(a)
        // a.click()
        // a.remove()

        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl)
        }, 10000)
      } catch (error) {
        console.error('go_wallet_ios error', error)
        alert(error?.message || 'Apple Walletへの遷移に失敗しました')
      }
    },
    async _go_wallet_ios(license_cd) {
      const url =
        config.BASE_API_URL +
        '/wallet/ios?testTkn=1&license_cd=' +
        license_cd +
        '&member_id=' +
        this.$store.state.auth.userId +
        '&access_token=' +
        this.$store.state.auth.token
      window.location.href = url
    },

    async go_wallet_android(license_id) {
      try {
        const params = {
          // testTkn: 1,
          member_license_id: license_id,
          // license_cd: license_cd,
          // member_id: this.$store.state.auth.userId
        }

        const response = await this.basicPosts_S(
          config.BASE_API_URL + '/wallet/android',
          params
        )

        const data = response?.data || {}

        if (Number(data.stat) !== 1 || !data.save_url) {
          throw new Error(data?.error || 'Google Wallet URLの取得に失敗しました')
        }

        window.location.href = data.save_url
      } catch (error) {
        console.error('go_wallet_android error', error)
        alert(error?.message || 'Google Walletへの遷移に失敗しました')
      }
    },
    async _go_wallet_android(license_cd) {
        try {
          const url =
            config.BASE_API_URL +
          '/wallet/android?testTkn=1&license_cd=' +
          encodeURIComponent(license_cd) +
          '&member_id=' +
          encodeURIComponent(this.$store.state.auth.userId) +
          '&access_token=' +
          encodeURIComponent(this.$store.state.auth.token)

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          },
          credentials: 'include'
        })

        if (!response.ok) {
          throw new Error('API request failed: ' + response.status)
        }

        const json = await response.json()

        if (!json || Number(json.stat) !== 1 || !json.save_url) {
          throw new Error(json?.error || 'Google Wallet URLの取得に失敗しました')
        }

        window.location.href = json.save_url
      } catch (error) {
        console.error('go_wallet_android error', error)
        alert(error.message || 'Google Walletへの遷移に失敗しました')
      }
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        // config.BASE_API_URL + '/license_cd/lists',
        config.BASE_API_URL + '/license_cd/get_dashboard',
        params
      )
        .then(async (response) => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async (response) => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseClassList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_class',
        params
      )
        .then(async (response) => {
          console.log('loadLicenseClassList response', response)
          this.license_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this.license_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async (response) => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async (response) => {
          console.log('loadLicenseCdObj', response)
          this.license_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this.license_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadTermYear(){
      const params = {};
      await this.basicPosts_S(
          config.BASE_API_URL + '/term_year/lists',
          params
      )
      .then(
          async (response) => {
              console.log('loadTermYear response', response);
              this.term_year_obj = (response.data && response.data.body)? response.data.body: [];
          }
      )
      .catch(
          async (err) => {
          console.log(err);
          this.term_year_obj = [];
      })
      .finally(async () => {
          this.$forceUpdate();
      });
    },
    async loadTermDate(){
      const params = {};
      await this.basicPosts_S(
          config.BASE_API_URL + '/term_date/lists',
          params
      )
      .then(
          async (response) => {
              console.log('loadTermDate response', response);
              this.term_date_obj = (response.data && response.data.body)? response.data.body: [];
          }
      )
      .catch(
          async (err) => {
          console.log(err);
          this.term_date_obj = [];
      })
      .finally(async () => {
          this.$forceUpdate();
      });
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/' + param,
        params
      )
        .then(async (response) => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadUserObj() {
      const params = {}
      params['stat'] = [1]
      params['id'] = this.$store.state.auth.userId
      await this.basicPosts_S(config.BASE_API_URL + '/member/lists', params)
        .then(async (response) => {
          console.log('loadUserObj', response)
          this.data_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async (err) => {
          console.log(err)
          this.data_obj = []
        })
        .finally(async () => {
          // await this.setUserObj()
          this.$forceUpdate()
        })
    },
    
    back_input() {
      this.change_mode = false
    },
    back() {
      this.$router.push({ path: '/' })
    },
  },
  computed: {
    ...mapState({}),
    get_license_obj: function () {
      return this.data_obj?.member_license?.filter((license) => parseInt(license.license_year) >= this.get_term_year) || []
    },
    get_term_year: function () {
      return typeof this.term_year_obj === 'object' &&
        typeof this.term_year_obj[0] === 'object' &&
        this.term_year_obj[0]['label']
        ? parseInt(this.term_year_obj[0]['label'])
        : parseInt(Common.getNowYear())
    },
  },
  async created() {
    await this.loadTermYear()
    await this.loadLicenseCdList()
    await this.loadEventCdList()
    await this.loadLicenseClassList()
    await this.loadLicenseCategoryList()
    await this.loadLicenseTypeObj()
    await this.loadTermDate()
    await this.loadConfigObj('request_type_cd')
    await this.loadConfigObj('sex_type')
    await this.loadConfigObj('application_type')
    await this.loadConfigObj('application_check_type')
    await this.loadUserObj()
  },
  mounted: function () {
    // console.log('tags_list', this.tags_list);
  },
  props: {},
}
</script>
